import { FC } from 'react';
import { Link } from '@remix-run/react';
import { Card } from '~/application/components/Card/Card';
import { Avatar } from '~/application/components/Avatar/Avatar';
import { useActivityItem, Props } from './useActivityItem';
import styles from './ActivitiyItem.module.css';

export const ActivityItem: FC<Props> = (props) => {
  const { activity, date, avatar } = useActivityItem(props);

  return (
    <Link
      to={`/users/${activity.user.id}/activities/${activity.id}`}
      className={styles.link}>

      <Card photo={activity.photo?.url}>
        {activity.scope.name === 'SPONSER' &&
        <div className={styles.sponsor}>スポンサー限定</div>}

        <time className={styles.date}>{date}</time>
        <div className={styles.title}>{activity.title}</div>
        <div>
          <Avatar src={avatar} name={activity.user.name} />
        </div>
      </Card>
    </Link>);

};